import { redirectToHomeIfNoDataAccess } from '@/data/router/guards';

const DataPage = () => import('@/data/pages/data.vue');

export const dataRoutes = [
  {
    path: '/data',
    name: 'data',
    component: DataPage,
    beforeEnter: redirectToHomeIfNoDataAccess,
  },
];
